<article [class.no-border]="hideBorder()">
  @if (showIcon() && iconName()) {
    <div class="icon-container">
      <umss-icon
        [name]="iconName()!"
        [size]="'24px'"
        [color]="'var(--color-icon-icon-alt)'"
      ></umss-icon>
    </div>
  }
  @if (title()) {
    <h4>{{ title() }}</h4>
  }
  @if (description()) {
    <p
      class="pg-regular"
      [style.color]="'var(--color-text-text-secondary)'"
      style="text-align: center"
    >
      {{ description() }}
    </p>
  }
  @if (showButton()) {
    <umss-button
      [label]="buttonLabel()"
      [variant]="buttonVariant()"
      [leftIconName]="buttonLeftIconName()"
      [rightIconName]="buttonRightIconName()"
      (click)="buttonClick.emit()"
    ></umss-button>
  }
</article>
